import * as Yup from "yup";
import form, { rolesForm } from "pages/account/manage/schemas/form";

const {
  formField: { displayName, designation, email, medicalID },
} = form;

const noValidation = Yup.object().shape({});

const validations = Yup.object().shape({
  [displayName.name]: Yup.string()
    .required(displayName.errorMsg)
    .max(200, displayName.invalidMsg),
  [designation.name]: Yup.string()
    .required(designation.errorMsg)
    .max(200, designation.invalidMsg),
  [email.name]: Yup.string()
    .required(email.errorMsg)
    .max(200, email.invalidMsg)
    .email(email.invalidMsg),
  [medicalID.name]: Yup.string()
    .required(medicalID.errorMsg)
    .max(200, medicalID.invalidMsg),
});

const {
  formField: { roleName },
} = rolesForm;

const rolesValidation = Yup.object().shape({
  [roleName.name]: Yup.string()
    .required(roleName.errorMsg)
    .max(200, roleName.invalidMsg)
    .nullable(true),
});

export { validations as default, noValidation, rolesValidation };
